// @ts-nocheck

import styled from 'styled-components';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import { Icon } from '../../../../components/ui';

export const Wrapper = styled.div.withConfig({ displayName: "styles__Wrapper", componentId: "sc-17wwfwc-0" })(["position:absolute;z-index:1000;bottom:0;left:0;right:0;background:white;margin:6px;"]);








export const Header = styled(Grid).withConfig({ displayName: "styles__Header", componentId: "sc-17wwfwc-1" })(["background:#3d4042;color:white;padding:0 16px;min-height:40px;"]);





export const HeaderItem = styled(GridItem).withConfig({ displayName: "styles__HeaderItem", componentId: "sc-17wwfwc-2" })(["display:flex;align-items:center;"]);



export const Content = styled.main.withConfig({ displayName: "styles__Content", componentId: "sc-17wwfwc-3" })([""]);
export const CloseIcon = styled(Icon).attrs(() => ({
  type: 'x',
  size: 12,
  color: 'white'
})).withConfig({ displayName: "styles__CloseIcon", componentId: "sc-17wwfwc-4" })(["position:absolute;right:14px;top:8px;cursor:pointer;"]);
